// extracted by mini-css-extract-plugin
export default {"twinkle":"reusable_twinkle__REwTu"};